module.exports = __webpack_public_path__ + "img/logo.789d57ad.png";